export class WarmwassercheckConstants {

  /**
   * Paths of the advisor
   */
  static readonly PATH_ERGEBNIS = '/warmwassercheck/ergebnis';
  static readonly PATH_EINGABE = '/warmwassercheck/eingabe/';
  static readonly PATH_STARTING_PAGE = '../../../start';

  /**
   * Certain steps of the advisor
   */
  static readonly FIRST_STEP_OF_INPUT = 'basisdaten/1';
  static readonly FIRST_STEP_OF_VERBRAUCHSDATEN = 'verbrauchsdaten/1'
  static readonly STEP_WW_BEKANNT = 'verbrauchsdaten/3'
  static readonly LAST_STEP_OF_CONSUMPTION_BEKANNT = 'verbrauchsdaten/4';
  static readonly LAST_STEP_OF_CONSUMPTION_GESCHAETZT = 'verbrauchsdaten/8';
  static readonly STEP_WASSERBEREITUNG_1 = 'wasserbereitung/1';
  static readonly STEP_WASSERBEREITUNG_2 = 'wasserbereitung/2';
  static readonly STEP_GERAETEDATEN_1 = 'geraetedaten/1';
  static readonly STEP_GERAETEDATEN_2 = 'geraetedaten/2';
  static readonly LAST_STEP_OF_GERAETEDATEN = 'geraetedaten/3';


  /**
   * Some values that are used in different cases
   */
  static readonly GEBAEUDETYP_EFH = '1-2familienhaus';
  static readonly GEBAEUDETYP_MFH = 'mehrfamilienhaus';
  static readonly NUTZUNGSTYP_HAUSEIGENTUEMER = 'hauseigentuemer';
  static readonly NUTZUNGSTYP_WOHNUNGSEIGENTUEMER = 'wohnungseigentuemer';
  static readonly NUTZUNGSTYP_MIETER = 'mieter';
  static readonly NUTZUNGSTYP_HAUSVERWALTER = 'hausverwalter';
  static readonly WARMWASSER_BEREITUNGSTYP_GEBAEUDEZENTRAL = 'gebaeudezentral';
  static readonly WARMWASSER_BEREITUNGSTYP_WOHNUNGSZENTRAL = 'wohnungszentral';
  static readonly WARMWASSER_BEREITUNGSTYP_DEZENTRAL = 'dezentral';
  static readonly ALL_FIELDS_WW_BEREITUNG_GERAETEDATEN = ['versorgung_technik', 'versorgung_geraet', 'speichervolumen', 'ww_geraet_baujahr', 'warmwasser_temperatur', 'waermemengenzaehler_vorhanden', 'ww_energieverbrauch'];

  /**
   * Some validation constants
   */
  static readonly FORM_PEOPLE_MAX = 5;
  static readonly FORM_PEOPLE_DEFAULT = 1;
  static readonly FORM_SHOWER_DURATION_MAX = 15;
  static readonly VALIDATE_DUSCHEN_ANZAHL_MAX_TAG = 3;
  static readonly VALIDATE_DUSCHEN_ANZAHL_MAX_WOCHE = 20;
  static readonly VALIDATE_DUSCHEN_ANZAHL_MAX_MONAT = 80;

  static readonly VALIDATE_BADEN_ANZAHL_MAX_WOCHE = 7;
  static readonly VALIDATE_BADEN_ANZAHL_MAX_MONAT = 30;
  static readonly VALIDATE_BADEN_ANZAHL_MAX_QUARTAL = 90;
  static readonly VALIDATE_BADEN_ANZAHL_MAX_JAHR = 360;

  static readonly VALIDATE_GESCHIRRSPUELEN_ANZAHL_MAX_TAG = 3;
  static readonly VALIDATE_GESCHIRRSPUELEN_ANZAHL_MAX_WOCHE = 20;

  static readonly VALIDATE_CONSUMPTION_MIN = 5 * 365;
  static readonly VALIDATE_CONSUMPTION_MAX = 80 * 365;

  static readonly POSTFIX_GESCHIRRSPUELEN = ['_wenig', '_normal'];

  static readonly VALIDATE_TEMPERATURE_MIN = 30;
  static readonly VALIDATE_TEMPERATURE_MAX = 70;

  static readonly VALIDATE_KLEINSPEICHER_MIN = 1;
  static readonly VALIDATE_KLEINSPEICHER_MAX = 30;
  static readonly VALIDATE_WANDSPEICHER_MIN = 30;
  static readonly VALIDATE_WANDSPEICHER_MAX = 200;
  static readonly VALIDATE_STANDSPEICHER_MIN = 200;
  static readonly VALIDATE_STANDSPEICHER_MAX = 2500;

  static readonly VALIDATE_WW_GERAET_BAUJAHR = 1950;
  static readonly VALIDATE_WW_ENERGIEVERBRAUCH_MIN = 100;
  static readonly VALIDATE_WW_ENERGIEVERBRAUCH_MAX = 12000;
}
